import { alpha, darken } from '@mui/material/styles';

export function buildAccordionPalette({ mode, brandMain, palette, darkElevated }) {
  const headerGradientStart = mode === 'dark' ? darken(brandMain, 0.2) : brandMain;
  const headerGradientEnd = mode === 'dark' ? brandMain : darken(brandMain, 0.15);
  const headerOverlay = mode === 'dark'
    ? 'linear-gradient(180deg, rgba(255,255,255,0.08), rgba(0,0,0,0.2))'
    : 'linear-gradient(180deg, rgba(255,255,255,0.35), rgba(0,0,0,0.05))';

  return {
    headerGradientStart,
    headerGradientEnd,
    headerOverlay,
    headerText: '#ffffff',
    icon: '#ffffff',
    bg: mode === 'dark' ? darkElevated : palette.background.paper,
    contentText: palette.text.primary,
    border: mode === 'dark' ? alpha('#ffffff', 0.12) : alpha('#000000', 0.08),
    shadow: mode === 'dark'
      ? '0 18px 40px rgba(0,0,0,0.55)'
      : '0 16px 38px rgba(0,0,0,0.1)',
  };
}
